var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaiwan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1086)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 19.9999C40 31.0456 31.0456 39.9999 20 39.9999C8.95435 39.9999 -3.05176e-05 31.0456 -3.05176e-05 19.9999C6.8695 13.1304 12.6956 7.30431 20 -6.10352e-05C31.0456 -6.10352e-05 40 8.95431 40 19.9999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 19.9999C20 8.95431 20 7.65213 20 -6.10352e-05C8.95434 -6.10352e-05 -3.05176e-05 8.95431 -3.05176e-05 19.9999H20Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3913 11.7047L14.9487 12.8538L16.2493 15.2193L13.5971 14.7118L13.2609 17.3913L11.4135 15.4207L9.56604 17.3913L9.23003 14.7118L6.57768 15.2192L7.87831 12.8536L5.43581 11.7047L7.87838 10.5559L6.57768 8.19026L9.22995 8.69768L9.56612 6.01831L11.4135 7.98894L13.261 6.01831L13.5971 8.69768L16.2494 8.19026L14.9487 10.556L17.3913 11.7047Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4139 15.4272C13.47 15.4272 15.1368 13.7604 15.1368 11.7043C15.1368 9.64818 13.47 7.98138 11.4139 7.98138C9.35777 7.98138 7.69098 9.64818 7.69098 11.7043C7.69098 13.7604 9.35777 15.4272 11.4139 15.4272Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4136 13.6884C10.3198 13.6884 9.42995 12.7985 9.42995 11.7046C9.42995 10.6108 10.3199 9.72089 11.4136 9.72089C12.5074 9.72089 13.3974 10.6108 13.3974 11.7046C13.3973 12.7985 12.5073 13.6884 11.4136 13.6884Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaiwan);
export default __webpack_public_path__ + "static/media/taiwan.db5a2a16179d502cb7781b84ae79724a.svg";
export { ForwardRef as ReactComponent };